import angular from 'angular';

export class FolhasPontoFalhaGeracaoModalController {
    static $inject = [
        '$uibModalInstance',
        'entity',
    ];

    constructor(
        public $uibModalInstance: ng.ui.bootstrap.IModalInstanceService,
        public entity: string,
    ) {
    }

    close() {
        this.$uibModalInstance.close();
    }
}
